import { httpRequest } from '@/request/utils/httprequest.js'
import baseUrl from '@/request/base.js'
import {baseconfig,rsaBasicModuleConfig} from '@/config.js'
import { rsa } from '@/tools/encrypt.js'
import { publicFun } from '@/tools/time.js'
import store from '@/store'
import qs from 'qs'

export const policydeclarationinfoModule = {
    // //policydeclarationinfo   填报申报
    async policydeclarationinfo(applyhousejson,applyuserjson,applyusergalleryjson,policy_measure_id,audit_status,original_value_json,mark) {
        const adminToken = store.getters.adminID
        var paras = {
            applyhousejson:applyhousejson,
            applyuserjson: applyuserjson,
            applyusergalleryjson:applyusergalleryjson,
            policy_measure_id:policy_measure_id,
            audit_status:audit_status,
            original_value_json:original_value_json,
            mark:mark,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(policy_measure_id) + String(audit_status)+'dasdfe',rsaBasicModuleConfig.clientPrivateKey)

        }
        console.log(paras)
        return await httpRequest(baseUrl.basic + 'policydeclarationinfo', 'put', qs.stringify(paras), null)
    }, 
    
    // 政策措施下拉框 HYT
    // /policymeasureinfoalllist
    async policymeasureinfoalllist() {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + '~H6q5f4sd',rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'policymeasureinfoalllist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign), 'get', null, null)
    },
    // 政策申报详情详情
    // /policydeclarationinfomodel
    async policydeclarationinfomodel(certificate_no,policy_measure_id) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + '~165asDI9',rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'policydeclarationinfomodel?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign)  + '&certificate_no=' + certificate_no+ '&policy_measure_id=' + policy_measure_id , 'get', null, null)
     },
    // // 政策申报详情通用 HYT详情 所有
    async policydeclarationinfomodelv2(apply_record_id,mark) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(apply_record_id)+ '~1613ASDI9',rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'policydeclarationinfomodelv2?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&apply_record_id=' + apply_record_id  + '&mark=' + mark, 'get', null, null)
     },
   
}
export const applyauditfailedlistModel = {
    // /applyauditfailedlist
    // 报审核-区级驳回待审--CGX
    async applyauditfailedlist(page,page_size,key_words) {
       const adminToken = store.getters.adminID
       var paras = {
           timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
           _sign: rsa.signString(baseconfig.v + adminToken + 'fsnjakf',rsaBasicModuleConfig.clientPrivateKey),
       }
       return await httpRequest(baseUrl.basic + 'applyauditfailedlist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&page_size=' + page_size + '&key_words=' + key_words , 'get', null, null)
    },
    ///applyauditfaileduserlist
   // 申报审核-区级驳回待审-申请人列表--CGX
    async applyauditfaileduserlist(page,page_size,policy_measure_id,key_words,region_level,region_id,id_number) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(policy_measure_id) + String(region_level) + String(region_id) + 'dg@srti',rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'applyauditfaileduserlist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&page_size=' + page_size  + '&key_words=' + key_words + '&region_level=' + region_level + '&region_id=' + region_id + '&policy_measure_id=' + policy_measure_id+ '&id_number=' + id_number  , 'get', null, null)
    },
    // 政策申报详情通用 HYT详情
    async policydeclarationinfomodelv2(policy_measure_id) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(policy_measure_id)+ '~1613ASDI9',rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'policydeclarationinfomodelv2?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&policy_measure_id=' + policy_measure_id , 'get', null, null)
     },
}
// // 年审审核
export const rewardannualreviewuserlistModel = {
    // /rewardannualreviewuserlist
    async rewardannualreviewuserlist(page,page_size,key_words,policy_measure_id,account_nature,year,audit_status,age_range_type,enjoy_census_region_level,enjoy_census_region_id,current_census_region_level,current_census_region_id,id_number) {
        const adminToken = store.getters.adminID
        // （v + AdminToken +policy_measure_id+account_nature+year+age_range_type+enjoy_census_region_id+current_census_region_id+ sfma#dsfnj ）
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(policy_measure_id) + String(account_nature) + String(year)+String(age_range_type) + String(enjoy_census_region_id)+ String(current_census_region_id) + 'sfma#dsfnj',rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'rewardannualreviewuserlist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) +
         '&page=' + page + '&page_size=' + page_size  +
          '&key_words=' + key_words+'&policy_measure_id=' + policy_measure_id
           + '&account_nature=' + account_nature + '&year=' + year+ '&audit_status=' + audit_status 
           + '&age_range_type=' + age_range_type + '&enjoy_census_region_level=' + enjoy_census_region_level
           + '&enjoy_census_region_id=' + enjoy_census_region_id + '&current_census_region_level=' + current_census_region_level
           + '&current_census_region_id=' + current_census_region_id + '&id_number=' + id_number
            , 'get', null, null)
    },
    // 批量审核
    // /rewardannualreviewbatchaudit
    async rewardannualreviewbatchaudit(apply_record_ids,user_ids,policy_measure_ids,is_audit_pass,no_pass_reason_id,audit_year,audit_time) {
        const adminToken = store.getters.adminID
        var paras = {
            policy_measure_ids: policy_measure_ids,
            user_ids: user_ids,
            apply_record_ids: apply_record_ids,
            is_audit_pass: is_audit_pass,
            no_pass_reason_id:no_pass_reason_id,
            audit_year: audit_year,
            audit_time:audit_time,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(apply_record_ids) + String(user_ids) + String(policy_measure_ids)+ String(is_audit_pass)+ String(no_pass_reason_id) + 'DFjdfs',rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'rewardannualreviewbatchaudit', 'post', qs.stringify(paras), null)
    },
    //申报审核-已完成-转年审--CGX  //rewardchangeannualreview
    async rewardchangeannualreview(apply_record_ids,user_ids,policy_measure_ids,mark) {
        const adminToken = store.getters.adminID
        var paras = {
            mark: mark,
            policy_measure_ids: policy_measure_ids,
            user_ids: user_ids,
            apply_record_ids: apply_record_ids,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(apply_record_ids) + String(user_ids) + String(policy_measure_ids) + String(mark)+ 'dfmserjk',rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'rewardchangeannualreview', 'post', qs.stringify(paras), null)
    },
}
// 年审未通过
export const rewardannualreviewfaileduserlistModel = {
    // /rewardannualreviewuserlist
    async rewardannualreviewfaileduserlist(page,page_size,key_words,policy_measure_id,account_nature,year,enjoy_census_region_level,enjoy_census_region_id,current_census_region_level,current_census_region_id,id_number) {
        const adminToken = store.getters.adminID
        // （v + AdminToken +policy_measure_id+account_nature+year+age_range_type+enjoy_census_region_id+current_census_region_id+ sfma#dsfnj ）
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(policy_measure_id) + String(account_nature) + String(year) + String(enjoy_census_region_id)+ String(current_census_region_id) + 'sfmdfsn',rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'rewardannualreviewfaileduserlist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) +
         '&page=' + page + '&page_size=' + page_size  +
          '&key_words=' + key_words+'&policy_measure_id=' + policy_measure_id
           + '&account_nature=' + account_nature + '&year=' + year+'&enjoy_census_region_level=' + enjoy_census_region_level
           + '&enjoy_census_region_id=' + enjoy_census_region_id + '&current_census_region_level=' + current_census_region_level
           + '&current_census_region_id=' + current_census_region_id + '&id_number=' + id_number
            , 'get', null, null)
    },
    // /rewardannualreviewbatchauditdistrict
    async rewardannualreviewbatchauditdistrict(reward_audit_record_ids,is_audit_pass,no_pass_reason_id,audit_year,audit_time) {
        const adminToken = store.getters.adminID
        var paras = {
            reward_audit_record_ids: reward_audit_record_ids,
            is_audit_pass: is_audit_pass,
            no_pass_reason_id:no_pass_reason_id,
            audit_year: audit_year,
            audit_time:audit_time,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(reward_audit_record_ids ) + String(is_audit_pass ) + String(no_pass_reason_id) + 'Dasd123Fjdfs',rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'rewardannualreviewbatchauditdistrict', 'post', qs.stringify(paras), null)
    },
}
// 

